/**
 * Production surface (garment F0) — the merged Floor + Board destination. The
 * `view` search param picks the lens: `station` (default) or `grid`.
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { FloorHomePage, type ProductionView } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/production/floor/")({
  // `view` is optional so bare `<Link to="/production/floor">` (e.g. the workbench back
  // button, the nav item) stays valid; it defaults to the by-station lens.
  validateSearch: (search: Record<string, unknown>): { view?: ProductionView } => ({
    view: search.view === "grid" ? "grid" : "station",
  }),
  component: FloorHomeRoute,
});

function FloorHomeRoute() {
  const { view } = Route.useSearch();
  return (
    <WorkspaceShell breadcrumbs={[{ label: "Production", to: "/" }, { label: "Production" }]}>
      <FloorHomePage view={view ?? "station"} />
    </WorkspaceShell>
  );
}
